import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificacaoService } from "../services/notificacao/notificacao.service";
import { Toast } from "../components/shared/toast/Toast";
import { formatarDataISO } from "../utils/date";
import Alert from "../components/shared/alert/Alert";

export const useNotificacoes = (user, datIni, datFim) => {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ["notificacoes", datIni, datFim],
        queryFn: async () => {
            try {
                const data = await NotificacaoService.listarNotificacoes(
                    user.token,
                    formatarDataISO(datIni || new Date()),
                    formatarDataISO(datFim || new Date())
                );
                return data;
            } catch (error) {
                const message = error.response?.data?.erro || error.message;
                await Toast({
                    icon: "error",
                    title: "Erro",
                    message: `Erro ao listar as notificações: ${message}`,
                });
                throw error;
            }
        },
        refetchInterval: 10000,
        staleTime: 20000,
    });

    const mutation = useMutation({
        mutationFn: async (arqs) =>
            await NotificacaoService.marcarLida(user.token, { arq487: arqs }),
        onSuccess: async (message, arqs) => {
            queryClient.setQueryData(["notificacoes", datIni, datFim], (data) =>
                data?.map((n) =>
                    arqs.includes(n.arq487) ? { ...n, notlid: "1" } : n
                ) || []
            );

            await Alert({
                icon: "success",
                title: "Sucesso",
                message: `${message.docs.mensagem}`,
                showConfirmButton: true,
                confirmButtonText: "OK",
            });
        },
        onError: async (error) => {
            const message = error.response?.data?.erro || error.message;
            await Alert({
                icon: "error",
                title: "Erro",
                message: `Erro ao marcar notificações como lida: ${message}`,
                showConfirmButton: true,
                confirmButtonText: "OK",
            });
        },
    });

    const qtdNaoLidas =
        query.data?.filter((n) => n.notlid !== "1").length || 0;

    return {
        ...query,
        marcarComoLida: mutation.mutate,
        qtdNaoLidas,
    };
};
